import styles from './index.module.scss'
import classNames from 'classnames';
import { Checkbox, Row, Col, Input, Collapse, Tag, DatePicker,Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState, useEffect, useMemo } from 'react';
import { sidebar } from "@/apis/discover";
import { useSearchParams } from 'react-router-dom';
import intl from 'react-intl-universal';
const CheckboxGroup = Checkbox.Group;
const { RangePicker } = DatePicker;

const OpenDetail = () => {
	const dataMap = {
		'openData':{
			title:"openData",
			desc:"放数据资源 (Open Data) 是指任何人都可以自由访问、使用、修改和共享的数据集，而不受法律、技术或财政方面的限制。",
			children:[{
				title:"",
				desc:"",

			}]
		}
	}
	return <div className={classNames(styles.openDataWrap)}>
		<div className={styles.bannerWrap}>
			<div className={styles.bannerContent}>
			<h1>开放数据</h1>
			<span>放数据资源 (Open Data) 是指任何人都可以自由访问、使用、修改和共享的数据集，而不受法律、技术或财政方面的限制。</span>
			</div>
		</div>
		<div className='container'>
		<Tabs
			defaultActiveKey="1"
			centered
			items={Array.from({
			length: 3,
			}).map((_, i) => {
			const id = String(i + 1);
			return {
				label: `Tab ${id}`,
				key: id,
				children: `Content of Tab Pane ${id}`,
			};
			})}
		/>
		</div>
	</div>
}
export default OpenDetail;